import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            商务合作
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            {contactData.subtitle}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200 rounded-xl p-8">
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 text-center">
              {contactData.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex flex-col items-center gap-2 p-5 bg-background-100 rounded-xl cursor-pointer hover:bg-background-200 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-50 rounded-xl">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <span className="text-xs text-foreground-400">邮箱</span>
                <span className="text-sm font-medium text-foreground-700">{contactData.email}</span>
              </div>

              <div className="flex flex-col items-center gap-2 p-5 bg-background-100 rounded-xl cursor-pointer hover:bg-background-200 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-50 rounded-xl">
                  <i className="ri-qq-line text-accent-500 text-xl"></i>
                </div>
                <span className="text-xs text-foreground-400">QQ</span>
                <span className="text-sm font-medium text-foreground-700">{contactData.qq}</span>
              </div>

              <div className="flex flex-col items-center gap-2 p-5 bg-background-100 rounded-xl cursor-pointer hover:bg-background-200 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-secondary-50 rounded-xl">
                  <i className="ri-wechat-line text-secondary-500 text-xl"></i>
                </div>
                <span className="text-xs text-foreground-400">微信</span>
                <span className="text-sm font-medium text-foreground-700">{contactData.wechat}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}